import React from 'react';
import { motion } from 'framer-motion';
import { MapPinIcon, GraduationCapIcon, BookOpenIcon } from 'lucide-react';
export function AboutMe() {
  return <section id="about" className="py-24 bg-white" data-id="element-13" data-mp="3t3vkh2flnvrc">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-14" data-mp="3edo2enti8er6">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-15" data-mp="3eb1uuo6m5z8y">
          {/* Photo / Visual Side */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="relative" data-id="element-16" data-mp="aw669dn3gw6l">
            <div className="aspect-[4/5] bg-charcoal-900 rounded-3xl overflow-hidden relative" data-id="element-17" data-mp="5v9u6csla3q3">
              <img src="https://cdn.magicpatterns.com/uploads/qdJVmqXJ5G7j3rdduZxFkG/52-IMG_5226.jpg" alt="Dr. McLean headshot" className="absolute inset-0 w-full h-full object-cover" data-id="element-18" data-mp="2mkf8dc9ig3rw" />
              <div className="absolute inset-0 bg-gradient-to-t from-charcoal-950/70 via-transparent to-transparent" data-id="element-19" data-mp="2dhzwu7qf7zkw"></div>
              <div className="absolute inset-0 flex items-end p-8" data-id="element-20" data-mp="2ri0znsq8xh30">
                <div className="bg-charcoal-950/80 backdrop-blur-sm rounded-2xl p-6 w-full" data-id="element-21" data-mp="2nf4o2lz4il8k">
                  <div className="flex items-center gap-3 mb-3" data-id="element-22" data-mp="31f5qi5v1e0q5">
                    <MapPinIcon size={20} className="text-amber-500" data-id="element-23" data-mp="31dcgqhp4n0dx" />
                    <span className="text-offwhite-100 font-medium" data-id="element-24" data-mp="2wfjcvvbaqigt">
                      Camarillo, California
                    </span>
                  </div>
                  <p className="text-offwhite-200 text-sm" data-id="element-25" data-mp="366dv8olf8xwz">
                    Proudly serving athletes and active individuals across
                    Ventura County
                  </p>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Content Side */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-26" data-mp="2ctxrawyutn9g">
            <h2 className="text-4xl md:text-5xl font-bold text-charcoal-950 mb-6" data-id="element-27" data-mp="2qmdmjblikgzt">
              Meet <span className="text-amber-500" data-id="element-28" data-mp="2vj430018delr">Dr. McLean</span>
            </h2>
            <div className="space-y-5 text-lg text-charcoal-800 leading-relaxed" data-id="element-29" data-mp="30i78fll4hmu9">
              <p data-id="element-30" data-mp="35hjuw5830rwb">
                I started McLean Physical Therapy because I was frustrated with
                the limitations of the traditional insurance-based model.
              </p>
              <p data-id="element-31" data-mp="1b4bu7wxfdm2r">
                As a cash-based practice, I'm able to provide a more modern,
                individualized approach to rehab and performance—focused on what
                actually helps you move forward.
              </p>
              <p data-id="element-32" data-mp="17mwis47qcda6">
                Whether you're dealing with a sports injury, recovering from
                surgery, navigating chronic or joint pain, or working on
                strength and performance, I'm here to help.
              </p>
              <p data-id="element-33" data-mp="tuq4kno50gdd">
                Together, we'll build a plan that helps you become more
                resilient, more confident, and more independent in managing your
                pain.
              </p>
            </div>

            <div className="mt-10 flex flex-wrap gap-6" data-id="element-34" data-mp="1llntdgndvgtk">
              <div className="flex gap-4 flex-row items-center" data-id="element-35" data-mp="1lk30dvgpw5xt">
                <div className="bg-offwhite-100 w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0" data-id="element-36" data-mp="1hiznnhtyuq0t">
                  <GraduationCapIcon size={24} className="text-amber-500" data-id="element-37" data-mp="1ckxycf5y5ugw" />
                </div>
                <div data-id="element-38" data-mp="66gnu05s6it3">
                  <h4 className="font-bold text-charcoal-950" data-id="element-39" data-mp="162d2acsourd">
                    Doctor of Physical Therapy
                  </h4>
                </div>
              </div>
              <div className="flex gap-4 flex-row items-center" data-id="element-40" data-mp="1p1fn8tbi62x6">
                <div className="bg-offwhite-100 w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0" data-id="element-41" data-mp="1tuihl3o3tgef">
                  <BookOpenIcon size={24} className="text-amber-500" data-id="element-42" data-mp="1g3n4tgahif5k" />
                </div>
                <div data-id="element-43" data-mp="1k4gvghfba825">
                  <h4 className="font-bold text-charcoal-950" data-id="element-44" data-mp="1k3xdx1tkplon">
                    B.S. in Exercise Science
                  </h4>
                </div>
              </div>
            </div>

            <div className="mt-10" data-id="element-45" data-mp="2crt73wjxovgo">
              <a href="https://calendly.com/dylanmclean-mcleanphysicaltherapy/consult-call" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 bg-amber-500 hover:bg-amber-400 text-charcoal-950 px-8 py-4 rounded-full font-bold text-lg transition-all transform hover:scale-105" data-id="element-46" data-mp="1ysk09nhmbdpd">
                Let's Work Together
              </a>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}